var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRori({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99 41",
    width: 99,
    height: 41,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff}.b{fill:#ce0085}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m59.6 26.1c0 9.4-7.1 14.8-15 14.8-7.8 0-14.9-5.4-14.9-14.8 0-9.5 7.1-14.8 14.9-14.8 7.9 0 15 5.3 15 14.8zm-9.8 0.2c0-4.7-2-7.6-5.4-7.6-3 0-5 2.4-5 7.1 0 4.8 2.1 7.7 5.5 7.7 3 0 4.9-2.4 4.9-7.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m62.9 12.3c1.9-0.4 4.2-0.8 7.2-0.8 1.7 0 2.6 0.8 2.6 2.2v2c1.5-2.5 4.2-4.4 7.7-4.4 3 0 5.2 1.2 5.2 2.9 0 2-1.9 4.2-4.1 5.5-1-0.7-2.3-1-3.5-1-2.8 0-4.7 2-5.3 5.2v16.3h-7.8c-1.3 0-2-0.5-2-1.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m88.2 4.5c0-2.9 2.2-4.4 5.1-4.4 2.8 0 5.3 1.6 5.3 4.6 0 2.9-2.2 4.5-5.1 4.5-2.8 0-5.3-1.7-5.3-4.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m1.7 39.5c-1 0-1.5-0.4-1.5-1.2v-27h14.3c7.4 0 11.9 3.8 11.9 10.2 0 3.7-1.9 6.7-4.7 8.4 0.6 1.1 1.4 2.3 2.1 3 0.8 0.7 1.6 1 2.6 1h0.7c0.3 0.8 0.5 1.8 0.5 3 0 1.4-4.2 3.1-6.8 3.1-2.4 0-3.9-0.8-5.5-2.8-1.1-1.3-2.3-3.7-2.9-5.6-0.7-0.1-1.5-0.2-2-0.4v8.3zm8.7-14.3c0.4 0.1 1 0.1 1.5 0.1 2.5 0 4.2-1.2 4.2-3.8 0-2.6-1.6-3.9-4.3-3.9h-1.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m95.7 11.5c-3 0-5.3 0.4-7.2 0.8v26.3c0 1.1 0.7 1.6 2 1.6h7.8v-26.5c0-1.4-0.9-2.2-2.6-2.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRori);
export default __webpack_public_path__ + "static/media/rori.fe59ac18960e1b106051c8c246e8c635.svg";
export { ForwardRef as ReactComponent };